import React from "react";

//styles
import styles from "./ProgressBar.module.scss";
import cx from "classnames";

// components
import Icon from "../Icon/Icon";

interface IProgressBarSection {
    sectionTitle: { sectionTitle: string; sectionTitleMobile: string };
    sectionNumber: number;
    sectionState: "active" | "upcoming" | "previous";
    isFinalSection: boolean;
}

const ProgressBarSection: React.FC<IProgressBarSection> = (props) => {
    const { sectionTitle, sectionState, isFinalSection, sectionNumber } = props;

    const getStylesByStage = (): string =>
        sectionState === "active"
            ? "--active"
            : sectionState === "previous"
            ? "--previous"
            : "--upcoming";

    return (
        <div
            className={cx(
                styles["section"],
                styles[`section${getStylesByStage()}`],
                "layout-flex-row--centered",
                {
                    [styles["last-item"]]: isFinalSection,
                    ["text-white"]: sectionState === "active",
                    ["text-brand"]: sectionState !== "active",
                }
            )}>
            <span
                className={cx(
                    "layout-flex-row--justify-centered",
                    "layout-flex-row--centered",
                    styles["stage-circle"],
                    styles[`stage-circle${getStylesByStage()}`]
                )}>
                {getStylesByStage() === "--previous" ? (
                    <Icon id="GreenCircle" />
                ) : (
                    sectionNumber
                )}
            </span>
            {getStylesByStage() === "--previous" ? (
                <span className={cx("layout-hidden-mobile", styles["stage-opacity"])}>{sectionTitle.sectionTitle}</span>
            ) : (<span className="layout-hidden-mobile">{sectionTitle.sectionTitle}</span>
            )}
            <span className="layout-hidden-desktop">
                {sectionTitle.sectionTitleMobile}
            </span>
        </div>
    );
};

export default ProgressBarSection;
